<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="320" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-4 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            {{ data && data.id ? 'Editar' : 'Crear' }} {{ data && data.parent_id ? 'subgrupo' : 'grupo' }}
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header>

      <div class="px-4 py-4 space-y-4 bg-white">
        <group-status-form ref="refGroupStatusForm"
          :group="data"
          :colorpickerInline="false"
          :show-actions="false"
          :layer-id="layerId"
        />
      </div>

      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="isModalActive = false">{{ $t('close') }}</v-button>
          <v-button v-if="!processingData" @click="addItem()" icon="save" size="is-small">{{ $t('save') }}</v-button>

          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import GroupStatusForm from './group-status-form.vue';

export default {
  name: "LayerGroupStatusModal",

  components: {
    GroupStatusForm
  },

  props: {
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      data: null,
      layerId: null,
    }
  },

  computed: {

  },

  created() {
  },

  methods: {
    async addItem() {
      // El modal ya no persiste. Arma el payload y emite hacia arriba.
      // El padre (group-statuses) llama al manager via :api, que hace
      // optimistic + POST + merge. Si falla, el manager hace rollback y
      // muestra error — el modal ya está cerrado (UX optimistic).
      const payload = this.$refs.refGroupStatusForm.buildPayload();
      this.$emit('epc-group-status-add', { payload });
      this.hide();
    },

    show(data, layerId) {
      this.data = data;
      this.layerId = layerId;
      this.isModalActive = true;
    },

    hide() {
      this.data = null;
      this.layerId = null;

      this.isModalActive = false;

    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
